import { NgModule } from '@angular/core';
import { SeoStoreModule } from './store';

@NgModule({
  imports: [SeoStoreModule],
})
export class SeoDataAccessModule {}
